import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Box } from "@material-ui/core";

const PRODUCT_SENDOUT_ORIGIN = "https://informationsharingservice.com";

function PublicSendout() {
    const { code } = useParams();

    useEffect(() => {
        if (!code) return;
        window.location.replace(`${PRODUCT_SENDOUT_ORIGIN}/${encodeURIComponent(code)}`);
    }, [code]);

    return (
        <Box display="flex" alignItems="center" justifyContent="center" minHeight="100vh">
            <CircularProgress size={50} />
        </Box>
    );
}

export default PublicSendout;
